import type { ReactNode } from 'react';
import type { UserSummary } from '@/types/user';
import { Bars3Icon } from '@heroicons/react/24/outline';
import { NotificationBell } from '@/components/shell/NotificationBell';
import { ThemeToggle } from '@/components/shell/ThemeToggle';
import { TimezoneSelect } from '@/components/shell/TimezoneSelect';
import { UserMenu } from '@/components/shell/UserMenu';

interface GlobalHeaderProps {
  portal: 'admin' | 'tenant';
  title?: string;
  onMenuToggle: () => void;
  notificationCount?: number;
  user: UserSummary;
  onLogout: () => void;
  headerActions?: ReactNode;
}

export function GlobalHeader({
  portal,
  title,
  onMenuToggle,
  notificationCount = 0,
  user,
  onLogout,
  headerActions,
}: GlobalHeaderProps) {
  return (
    <header
      className="sticky top-0 z-30 flex h-header items-center gap-2 border-b border-[var(--border-subtle)] bg-[var(--bg-glass)] px-3 backdrop-blur sm:gap-3 sm:px-4"
      style={{ height: 'var(--header-height)' }}
    >
      <button
        type="button"
        className="rounded-lg p-2 text-secondary hover:bg-[var(--bg-card-hover)] lg:hidden"
        onClick={onMenuToggle}
        aria-label="Open navigation menu"
      >
        <Bars3Icon className="h-5 w-5" />
      </button>
      <div className="min-w-0 flex-1">
        <p className="truncate text-sm font-semibold text-[var(--text-primary)]">
          {title ?? (portal === 'admin' ? 'SCUBE Admin' : 'SCUBE Tenant')}
        </p>
      </div>
      <div className="hidden sm:flex sm:items-center sm:gap-2">
        {headerActions}
      </div>
      <NotificationBell count={notificationCount} />
      <div className="hidden lg:block">
        <TimezoneSelect compact />
      </div>
      <ThemeToggle />
      <UserMenu user={user} onLogout={onLogout} />
    </header>
  );
}
